import { useMemo } from 'react';

import useMultiPortfolioStore from 'lib/stores/multiPorto';
import { SubAccountStatus } from 'global/Securities/types/api/multiPorto';

export default function useSubAccounts() {
  const subAccountsData = useMultiPortfolioStore((s) => s.subAccountsData);
  const subAccountsLoading = useMultiPortfolioStore(
    (s) => s.subAccountsData?.isLoading,
  );
  const activeAccount = useMultiPortfolioStore((s) => s.activeAccount);
  const getSubAccounts = useMultiPortfolioStore((s) => s.getSubAccounts);

  const regularAccounts = useMemo(
    () => subAccountsData?.data?.regular?.accounts ?? [],
    [subAccountsData?.data?.regular?.accounts],
  );

  const marginAccounts = useMemo(
    () => subAccountsData?.data?.margin?.accounts ?? [],
    [subAccountsData?.data?.margin?.accounts],
  );

  const subAccounts = useMemo(
    () => [...regularAccounts, ...marginAccounts],
    [regularAccounts, marginAccounts],
  );

  const canCreatePortfolio = useMemo(
    () => subAccountsData?.data?.regular?.can_create_new_account,
    [subAccountsData?.data?.regular?.can_create_new_account],
  );

  const subAccountError = useMemo(
    () => subAccountsData?.error,
    [subAccountsData?.error],
  );

  const approvedSubAccounts = useMemo(
    () =>
      subAccounts.filter(
        (sub) => sub.account_status === SubAccountStatus.APPROVED,
      ),
    [JSON.stringify(subAccounts)],
  );

  const activePortfolio = subAccounts.find(
    (sub) => sub.account_number === activeAccount,
  );

  const activeAccountName = useMemo(() => {
    if (subAccounts.length > 1 && activePortfolio) {
      return activePortfolio.portfolio_info.portfolio_name || '';
    }

    return '';
  }, [activePortfolio?.portfolio_info.portfolio_name, subAccounts.length]);

  return {
    subAccounts,
    approvedSubAccounts,
    canCreatePortfolio,
    subAccountError,
    activeAccountName,
    activePortfolio,
    isLoading: subAccountsLoading,
    multiPortoList: subAccounts,
    regularPortoList: regularAccounts,
    marginPortoList: marginAccounts,
    getSubAccounts,
  };
}
